/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-22 21:35:02
 */

import SynthesizeReport from '../synthesizeReport';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import SynthesizeReportApi, { SynthesizeReportDOI } from '../api/synthesizeReportApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';

export default class SynthesizeReportService extends ListPageService {
    ctx: SynthesizeReport;

    constructor(ctx: SynthesizeReport) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        let last, current, lastEn, currentEn;
        switch (t.ctx.currentDataType) {
            case '日报':
                last = '昨日';
                current = '今日';
                lastEn = 'yesterday_water';
                currentEn = 'today_water';
                break;
            case '周报':
                last = '上周';
                current = '本周';
                lastEn = 'last_week_water';
                currentEn = 'this_week_water';
                break;
            case '月报':
                last = '上月';
                current = '本月';
                lastEn = 'last_month_water';
                currentEn = 'this_month_water';
                break;
            case '年报':
                last = '去年';
                current = '今年';
                lastEn = 'last_year_water';
                currentEn = 'this_year_water';
                break;
        }
        let cols: ColDefCustom[] = [
            {
                headerName: '站点名称',
                field: 'device_name',
                minWidth: 180,
            },
            {
                headerName: last,
                field: lastEn,
                minWidth: 100,
            },
            {
                headerName: current,
                field: currentEn,
                minWidth: 100,
            },
            {
                headerName: '主要污染物',
                field: 'contaminant',
                minWidth: 100,
            },
            {
                headerName: '停运率',
                field: 'outage_rate',
                minWidth: 65,
            },
            {
                headerName: '故障率',
                field: 'failure_rate',
                minWidth: 65,
            },
            {
                headerName: '数据传输率',
                field: 'data_transfer_rate',
                minWidth: 85,
            },
        ];
        return cols;
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        if (this.ctx.currentDataType === '日报') {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'date', format: 'yyyy-MM-dd', placeholder: '请选择时间', clearable: false },
                },
            ];
        } else if (this.ctx.currentDataType === '周报') {
            return [
                {
                    component: 'el-date-picker',
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'week', format: 'yyyy 第 WW 周', placeholder: '请选择时间', clearable: false },
                },
            ];
        } else if (this.ctx.currentDataType === '月报') {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'month', format: 'yyyy-MM', placeholder: '请选择时间', clearable: false },
                },
            ];
        } else {
            return [
                {
                    component: DatePicker,
                    label: '时间',
                    field: 'time',
                    width: 250,
                    props: { value: new Date(), type: 'year', format: 'yyyy', placeholder: '请选择时间', clearable: false },
                },
            ];
        }
    }

    @override
    initSearchParams(): void {
        if (this.ctx.ids.length === 0) {
            return;
        }
        let params: any = this.ctx.queryForm.getQueryObj<SynthesizeReportDOI.QueryRowDataParamsI>();
        let endTime, startTime;
        switch (this.ctx.currentDataType) {
            case '日报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'start');
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'end');
                break;
            case '周报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'weekStart');
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'weekEnd');
                break;
            case '月报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'monthStart');
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'monthEnd');
                break;
            case '年报':
                startTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'yearStart');
                endTime = DateTimeUtil.getSecondFromIviewDate(params.time, 'yearEnd');
                break;
        }
        this.ctx.searchParams = {
            ids: this.ctx.ids,
            start_time: startTime,
            end_time: endTime,
        };
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        if(ctx.ids.length === 0) {return}
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let api;
        if (this.ctx.currentDataType === '日报') {
            api = SynthesizeReportApi.searchDayList;
        } else if (this.ctx.currentDataType === '周报') {
            api = SynthesizeReportApi.searchWeekList;
        } else if (this.ctx.currentDataType === '月报') {
            api = SynthesizeReportApi.searchMonthList;
        } else {
            api = SynthesizeReportApi.searchYearList;
        }
        let { code, data } = await api({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            let cols = this.createColumns();
            cols.splice(
                2,
                0,
                ...data.header.map((i, index) => ({
                    headerName: `${i.name}(${i.unit})`,
                    field: i.key,
                    minWidth: 100,
                })),
            );
            ctx.columnDefs = cols;
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
